const points = {
  title: 'Points Record',
  all: 'All',
  balance: {
    contact: 'Contact Points',
    aiMatch: 'AI Credits',
  },
  balanceSummary: {
    title: 'Current Balance',
    description:
      'View the remaining points available for contact retrieval and candidate analysis.',
  },
  usageTips: {
    title: 'AI credit usage',
    description: 'AI credits are charged per candidate in the following scenarios',
    cost: '1 AI credit / candidate',
    tag: {
      title: 'Tag candidate analysis',
      description: 'Analyze Chinese identity and China-company experience.',
    },
    job: {
      title: 'Job match analysis',
      description: 'Analyze candidate-job fit.',
    },
    inmail: {
      title: 'AI InMail generation',
      description: 'Generate one AI InMail message for each candidate.',
    },
  },
  modes: {
    consume: 'Consumption',
    all: 'All Records',
  },
  filters: {
    typePlaceholder: 'Point Type',
    actionPlaceholder: 'Scenario',
    limitPlaceholder: 'Rows per page',
    limitOption: '{value} / page',
  },
  actions: {
    refresh: 'Refresh',
  },
  columns: {
    time: 'Time',
    pointsType: 'Point Type',
    scene: 'Scenario',
    change: 'Change',
    balanceBefore: 'Before',
    balanceAfter: 'After',
    description: 'Description',
  },
  types: {
    contact: 'Contact Points',
    aiMatch: 'AI Credits',
  },
  actionsMap: {
    recharge: 'Recharge',
    member_reward: 'Member Reward',
    referral_reward: 'Referral Reward',
    system_gift: 'System Gift',
    special_purchase: 'Purchase Contact',
    system_recycle: 'System Deduction',
    ai_match: 'AI Match Analysis',
    resume_import: 'Resume Import',
    inmail_generation: 'Generate InMail',
  },
  subject: {
    candidate: 'Candidate: {name}',
    generic: '{type}: {name}',
    relatedCandidates: 'Related candidates ({count}): {names}{suffix}',
    moreSuffix: ', etc.',
  },
  empty: 'No points records',
  errors: {
    balance: 'Failed to load points balance',
    records: 'Failed to load points records',
  },
}

export default points
